import React from "react";

const DEFAULT_DISTRIBUTION = [
  { id: 1, label: "Yoruba To English", count: 45200, percentage: 85, badge: "+15%" },
  { id: 2, label: "Swahili To English", count: 32000, percentage: 60, badge: "+12%" },
  { id: 3, label: "Nigerian Pidgin To English", count: 28900, percentage: 50, badge: "+8%" },
  { id: 4, label: "English To Yoruba", count: 15300, percentage: 30, badge: "+5%" },
  { id: 5, label: "Other Combinations", count: 8500, percentage: 15, badge: "+3%" },
];

const LanguageDistributionCard = ({ items = DEFAULT_DISTRIBUTION }) => {
  return (
    <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm h-full flex flex-col justify-between min-h-[360px]">
      <h3 className="text-xl font-bold text-gray-900 mb-4">
        Top Language Distribution For All Users
      </h3>

      <div className="space-y-4 my-auto">
        {items.map((item) => (
          <div key={item.id} className="space-y-1.5">
            <div className="flex items-center justify-between text-sm">
              <span className="font-semibold text-gray-800">{item.label}</span>
              <div className="flex items-center gap-3">
                <span className="font-medium text-gray-600">
                  {item.count.toLocaleString()}
                </span>
                <span className="bg-[#E8F8F0] text-[#10B981] text-xs font-semibold px-2 py-0.5 rounded-md">
                  {item.badge}
                </span>
              </div>
            </div>

            {/* Progress bar */}
            <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden">
              <div
                className="bg-[#0E5E44] h-full rounded-full transition-all duration-500"
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageDistributionCard;
